interface QuartileSparkChartProps {
    min: number | null;
    q1: number | null;
    median: number | null;
    q3: number | null;
    max: number | null;
    className?: string;
}

function QuartileSparkChart({ min, q1, median, q3, max, className }: QuartileSparkChartProps) {
    if (min === null || q1 === null || median === null || q3 === null || max === null || max === min) {
        return <span className="text-muted-foreground text-xs">-</span>;
    }

    const width = 150;
    const height = 30;
    const padding = 8;
    const rangeWidth = width - padding * 2;
    const valueRange = max - min;
    const x = (v: number) => padding + ((v - min) / valueRange) * rangeWidth;

    const minX = x(min);
    const q1X = x(q1);
    const medianX = x(median);
    const q3X = x(q3);
    const maxX = x(max);

    const centerY = Math.round(height / 2);
    const boxTop = 8;
    const boxHeight = 14;

    return (
        <svg width={width} height={height} className={className} aria-label="Quartile distribution spark chart">
            {/* Base track for visual balance */}
            <line
                x1={padding}
                y1={centerY}
                x2={width - padding}
                y2={centerY}
                stroke="hsl(var(--muted-foreground) / 0.2)"
                strokeWidth={2}
                strokeLinecap="round"
            />

            {/* Whiskers */}
            <line
                x1={minX}
                y1={centerY}
                x2={maxX}
                y2={centerY}
                stroke="hsl(var(--muted-foreground) / 0.65)"
                strokeWidth={1.5}
                strokeLinecap="round"
            />
            <line
                x1={minX}
                y1={boxTop + 1}
                x2={minX}
                y2={boxTop + boxHeight - 1}
                stroke="hsl(var(--muted-foreground) / 0.75)"
                strokeWidth={1.5}
            />
            <line
                x1={maxX}
                y1={boxTop + 1}
                x2={maxX}
                y2={boxTop + boxHeight - 1}
                stroke="hsl(var(--muted-foreground) / 0.75)"
                strokeWidth={1.5}
            />

            {/* Interquartile range box */}
            <rect
                x={q1X}
                y={boxTop}
                width={Math.max(1, q3X - q1X)}
                height={boxHeight}
                rx={4}
                fill="hsl(var(--chart-1) / 0.25)"
                stroke="hsl(var(--chart-1) / 0.85)"
                strokeWidth={1.5}
            />

            {/* Median */}
            <line
                x1={medianX}
                y1={boxTop}
                x2={medianX}
                y2={boxTop + boxHeight}
                stroke="hsl(var(--chart-1))"
                strokeWidth={2.5}
                strokeLinecap="round"
            />
        </svg>
    );
}

export default QuartileSparkChart;
